<template>
    <tr class="order-product-line" :class="[highlight && nbOrdered > 0 ? 'highlighted' : '', 'order-product-line-' + sku]">
        <td class="order-product-line-label" :class="{'text-danger': hasWarnings}">
            <button v-if="hasWarnings" class="btn btn-sm btn-danger" type="button" @click="warnReasonsDisplayed = !warnReasonsDisplayed">
                <i class="fad fa-exclamation-triangle"></i>
            </button>
            {{ label }}
            <template v-if="hasWarnings">
                <ul v-if="warnReasonsDisplayed" class="list-group p-1">
                    <li v-for="reason in warnReasons" :key="reason" class="list-group-item list-group-item-danger p-1">
                        {{ reason }}
                    </li>
                </ul>
            </template>
        </td>
        <td v-if="unitPrice" class="order-product-line-total">
            {{ formatPrice(unitPrice) }} €
        </td>
        <td class="order-product-line-quantity">
            <input v-if="!readonly"
                   class="form-control p-0"
                   type="number"
                   min="0"
                   v-model="nbOrdered"
                   @focus="onFocus"
                   @input="onInput"
            >
            <span v-else>{{ nbOrdered }}</span>
        </td>
        <td v-if="unitPrice" class="order-product-line-total">
            {{ formatPrice(unitPrice.toFixed(2) * nbOrdered) }} €
        </td>
    </tr>
</template>

<script>
    import {formatPrice} from "../helpers";

    export default {
        props: {
            sku: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
            value: {
                type: Number,
                required: false,
                default: 0,
            },
            unitPrice: {
                type: Number,
                required: false,
                default: 0,
            },
            warnReasons: {
                type: Array,
                required: false,
            },
            readonly: {
                type: Boolean,
                required: false,
                default: false,
            },
            highlight: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data: function () {
            return {
                nbOrdered: this.value || 0,
                warnReasonsDisplayed: false,
            };
        },

        watch: {
            value(newValue, oldValue) {
                this.nbOrdered = newValue;
            }
        },

        methods: {
            onInput(event) {
                this.$emit('input', parseInt(event.target.value));
            },

            onFocus(event) {
                event.target.select();
            },

            formatPrice,
        },

        computed: {
            hasWarnings() {
                return this.warnReasons && this.warnReasons.length > 0;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .highlighted {
        background-color: darkseagreen;
    }

    .order-product-line-quantity {
        text-align: right;
    }

    .order-product-line-total {
        text-align: right;
    }
</style>
